const types = {
  FETCHPASSAGEPASSVALIDATION: "FETCHPASSAGEPASSVALIDATION",
  EDITPASSAGEPASSVALIDATION: "EDITPASSAGEPASSVALIDATION",
  CREATEPASSAGEPASSVALIDATION: "CREATEPASSAGEPASSVALIDATION",
};
export default types;
